// ERROR
export const SUPPORTED_ERRORS_CODES = [404, 500, 503];

// STORAGE
export const STORAGE_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const STORAGE_VALID_TO = 'VALID_TO';
export const STORAGE_USER = 'USER';
export const STORAGE_USER_DOCUMENTATION_LANGUAGE = 'USER_DOCUMENTATION_LANGUAGE';
export const STORAGE_CHAT_USER = 'CHAT_USER';

// CREDIT
export const CREDIT_CONSTANT_C_HIGHER = 0.1095;
export const CREDIT_CONSTANT_C_LOWER = 0.069;

// Mask input
export const MASK_SWISS_PHONE_NUMBER = '__ ___ __ __';

// OTHER
export const NATIONALITY_PRIORITY_LIST = [
  "SWITZERLAND",
  "GERMANY",
  "AUSTRIA",
  "LIECHTENSTEIN",
  "FRANCE",
  "ITALY",
  "SERBIA",
  "PORTUGAL",
  "SPAIN",
  "TURKEY"
];